// extracted by mini-css-extract-plugin
export default {"container":"Products_container__om1n4","products":"Products_products__YG8NM","menu":"Products_menu__S2n9A","list":"Products_list__yUZqK","product":"Products_product__01Pe9"};